import { Reducer } from 'redux';
import { GeneralState, GeneralActions, MEMBER_REGISTER_GENERAL__SET_ACCESSIBLE_STEP, MEMBER_REGISTER_GENERAL__SAVE_CLAUSES_PAGE_DATA, MEMBER_REGISTER_GENERAL__SAVE_PERSONAL_INFO_PAGE_DATA, MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP_DONE, MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP_DONE, MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP_DONE, MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA_DONE, MEMBER_REGISTER_GENERAL__UPDATE_CACHE, MEMBER_REGISTER_GENERAL__RESET_CACHE } from './types';

const initialState: GeneralState = {
  process: {
    accessibleSteps: [],
    clauses: {},
    personalInfo: {},
    confirmInfo: {
      otpAuth: {}
    },
    complete: {}
  }
};

const generalReducer: Reducer<GeneralState, GeneralActions> = (state = initialState, action): GeneralState => {
  switch (action.type) {
    // 設置可訪問步驟
    case MEMBER_REGISTER_GENERAL__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 緩存「同意相關告知事項」(Step-1) 頁面資料
    case MEMBER_REGISTER_GENERAL__SAVE_CLAUSES_PAGE_DATA: {
      return { ...state, process: { ...state.process, clauses: { ...state.process.clauses, data: action.payload.data } } };
    }
    // 緩存「填寫資料」(Step-2) 頁面資料
    case MEMBER_REGISTER_GENERAL__SAVE_PERSONAL_INFO_PAGE_DATA: {
      return { ...state, process: { ...state.process, personalInfo: { ...state.process.personalInfo, data: action.payload.data } } };
    }
    // 發送手機 OTP 驗證碼 完成
    // 重新發送手機 OTP 驗證碼 完成
    case MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP_DONE:
    case MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP_DONE: {
      return { ...state, process: { ...state.process, confirmInfo: { ...state.process.confirmInfo, otpAuth: { ...state.process.confirmInfo.otpAuth, mobile: action.payload.response } } } };
    }
    // 發送信箱 OTP 驗證碼 完成
    case MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP_DONE: {
      return { ...state, process: { ...state.process, confirmInfo: { ...state.process.confirmInfo, otpAuth: { ...state.process.confirmInfo.otpAuth, email: action.payload.response } } } };
    }
    // 送出會員資料執行註冊 完成
    case MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA_DONE: {
      return { ...state, process: { ...state.process, complete: { ...state.process.complete, referralCode: action.payload.response.ReferralCode } } };
    }
    // 更新流程資料緩存
    case MEMBER_REGISTER_GENERAL__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case MEMBER_REGISTER_GENERAL__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default generalReducer;
